import * as React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { CSSProperties } from 'react';

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 200 } };

export const Select = ({
  options,
  onChange,
  label,
  placeholder,
  style,
  initialSelectedKey,
}: {
  options: IDropdownOption[];
  onChange: (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => void;
  label: string;
  placeholder: string;
  style?: CSSProperties;
  initialSelectedKey?: string;
}) => {
  const [selectedItem, setSelectedItem] = React.useState<IDropdownOption | undefined>(() => {
    if (initialSelectedKey) {
      return options.find(opt => opt.key === initialSelectedKey);
    }
    return undefined;
  });

  const _onChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    setSelectedItem(item);
  };

  return (
    <Dropdown
      label={label}
      selectedKey={selectedItem ? selectedItem.key : undefined}
      onChange={(event, item) => {
        onChange(event, item!);
        _onChange(event, item!);
      }}
      placeholder={placeholder}
      options={options}
      style={style}
      styles={dropdownStyles}
    />
  );
};
